import React from 'react'
import { Checkbox, Typography } from 'antd'
import { Metric, MetricKey } from '../campaigns/PerformanceChart/types'

const { Text } = Typography

interface MetricSelectorProps {
  value: MetricKey[]
  onChange: (checkedValues: MetricKey[]) => void
  metrics: Metric[]
  className?: string
  title?: string
  gridCols?: number
}

export const MetricSelector: React.FC<MetricSelectorProps> = ({
  value,
  onChange,
  metrics,
  className = '',
  title = 'Metrics:',
  gridCols = 2
}) => {
  const gridClass = `grid grid-cols-${gridCols} md:grid-cols-${Math.min(gridCols + 1, 4)} gap-2`

  return (
    <div className={className}>
      <Text strong className="mb-2 block">{title}</Text>
      <Checkbox.Group
        value={value}
        onChange={onChange}
        className="w-full"
      >
        <div className={gridClass}>
          {metrics.map(metric => (
            <Checkbox key={metric.key} value={metric.key}>
              {metric.label}
            </Checkbox>
          ))}
        </div>
      </Checkbox.Group>
    </div>
  )
}
